// extracted by mini-css-extract-plugin
module.exports = {"wrap":"dhcl_wrap_2JvT1","fanhui":"dhcl_fanhui_goZoq","btnWrap":"dhcl_btnWrap_3GBmN","btn":"dhcl_btn_nW84f","fullScreen":"dhcl_fullScreen_2bqYu"};